import React, { useEffect } from 'react'
import { RouteComponentProps } from '@reach/router'
import { PanelContent } from '../../../components/panel-content'
import { useStateValue } from '../../../components/state'
import { Video } from '../../../components/video'
import { Button } from '../../../components/button'
import { useDelayedBoolean } from '../../../hooks/use-delayed-boolean'
import { MapFact } from '../../../components/map-fact'

export const RecycledIrrigation: React.FC<RouteComponentProps> = () => {
  const [, dispatch] = useStateValue()

  // Filter map pins to desalination
  useEffect(() => {
    dispatch({
      type: 'setActiveMarkerType',
      payload: { activeMarkerType: 'wastewater-treatment' }
    })
  }, [dispatch])

  const factVisible = useDelayedBoolean({ delay: 500 })

  return (
    <PanelContent>
      <h1>Water recycling for irrigation</h1>
      <p>
        In an environment affected by climate change, making the most of our
        treated wastewater through recycling is very important. We recycle
        wastewater in a number of ways, such as irrigating agricultural areas
        and public spaces and through industry use.
      </p>
      <Video videoId='V9sTSqgf7vI' />
      <MapFact
        aboveValue='Our goal is recycle 30% of our wastewater by 2030.'
        visible={factVisible}
        position='bottom-left'
      />
      <Button href='https://www.watercorporation.com.au/Our-water/Sustainability-and-innovation/Water-recycling'>
        Learn more about water recycling
      </Button>
    </PanelContent>
  )
}
